import * as React from 'react';

export const Logo40SeasRow = ({ style }: { style?: React.CSSProperties }) => (
    <svg style={style} id="Warstwa_6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 268 36">
        <defs></defs>
        <path
            fill="#0D49E1"
            d="M133.96,14.78c-6.08-.4-10.79-.98-10.79-4.2,0-3.45,5.59-4.31,9.6-4.31,5.42,.06,9.38,1.78,12.25,4.14l3.31-4.37c-3.47-2.7-9.16-5-15.24-5-9.98,0-15.94,3.79-15.94,9.94,0,6.72,7.7,8.74,15.78,9.37,7,.58,10.85,1.55,10.85,4.71s-4.23,4.66-9.71,4.66c-6.35,0-11.17-2.07-14.64-5.23l-3.41,3.97c4.28,3.97,10.63,6.5,17.9,6.5,10.47,0,15.89-4.6,15.89-10.46,0-6.38-6.73-9.02-15.84-9.71Z"
        />
        <path
            fill="#0D49E1"
            d="M171.1,1.05c-11.44,0-18.28,6.55-18.28,17.01s6.84,16.9,18.71,16.9c6.94,0,12.1-1.78,16.16-5.63l-3.69-4.2c-3.25,3.04-6.67,4.54-12.15,4.54-7.49,0-12.2-3.33-12.8-10.17h29.5c.11-.34,.16-.75,.16-1.49,0-11.03-6.94-16.95-17.63-16.95Zm-11.77,13.68c1.19-5.58,5.59-8.39,11.82-8.39,5.86,0,10.09,2.59,11.45,8.33l-23.27,.06Z"
        />
        <path
            fill="#0D49E1"
            d="M226.47,16.22c0-9.88-6.35-15.11-16.7-15.11-5.37,0-11.07,1.55-14.75,3.91l2.28,4.54c3.42-2.13,6.89-3.16,11.28-3.16,7.65,0,11.55,3.05,11.55,9.83v2.3c-2.33-3.05-6.89-5.63-12.96-5.63-6.4,0-14.91,2.76-14.91,10.98s8.51,11.03,14.91,11.03,10.63-2.59,12.96-5.63v.06c0,1.49,.38,3.04,1.14,4.42h6.56c-.98-1.84-1.36-3.74-1.36-6.09v-11.44Zm-6.24,8.16c-2.39,4.31-7.43,5.69-11.88,5.69-3.96,0-9.87-1.09-9.87-6.21s5.91-6.15,9.87-6.15c4.45,0,9.49,1.32,11.88,5.69v.98Z"
        />
        <path
            fill="#0D49E1"
            d="M249.78,14.78c-6.08-.4-10.79-.98-10.79-4.2,0-3.45,5.59-4.31,9.6-4.31,5.42,.06,9.38,1.78,12.26,4.14l3.31-4.37c-3.47-2.7-9.16-5-15.24-5-9.98,0-15.94,3.79-15.94,9.94,0,6.72,7.7,8.74,15.78,9.37,7,.58,10.85,1.55,10.85,4.71s-4.23,4.66-9.71,4.66c-6.35,0-11.17-2.07-14.64-5.23l-3.41,3.97c4.28,3.97,10.63,6.5,17.9,6.5,10.47,0,15.89-4.6,15.89-10.46,0-6.38-6.73-9.02-15.84-9.71Z"
        />
        <path
            fill="#0D49E1"
            d="M32.27,2.09h-5.18L2.39,22.94v3.82H26.6v7.1h5.67v-7.1h6.56v-4.76h-6.56V2.09Zm-5.72,19.9H10.08L26.55,8.52v13.48Z"
        />
        <path fill="#0D49E1" d="M90.82,18c0-13-11-9-11.02-17h-5.99c2.01,5,11.01,4,11.01,17s-9,12-11.01,17h5.99c.02-8,11.02-4,11.02-17Z" />
        <path fill="#0D49E1" d="M102.82,18.03c0-10-10-3-11-16.96h-6c0,9.96,11,4.96,11,16.96s-11,7-11,16.97h6c1-13.97,11-6.97,11-16.97Z" />
        <path fill="#0D49E1" d="M103.82,1h-6c0,14,11,10,11,17s-11,3-11,17h6c1-17,11-12,11-17s-10,0-11-17Z" />
        <path
            fill="#0D49E1"
            d="M78.82,18c0-10-4.88-10.15-8-12.72-4-3.29-6-4.28-10-4.24-5,.06-19,1.05-19,16.95s14,16.87,19,16.94c4,.06,6-.94,10-4.24,3.12-2.57,8-2.7,8-12.7Zm-6,0c0,6.44-4,11.66-12.5,11.66s-12.5-5.22-12.5-11.66,4-11.66,12.5-11.66,12.5,5.22,12.5,11.66Z"
        />
    </svg>
);
